import { Trans } from '@lingui/macro'
import { Paper } from '@material-ui/core'
import { css } from 'emotion'
import React from 'react'

import { CenterContainer } from '../atoms/CenterContainer'
import { FailureText } from '../atoms/FailureText'

const paper = css`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 30%;
  padding: 1rem;
  max-width: 28rem;
`

export const AccountNotFound: React.FC = () => {
  return (
    <CenterContainer>
      <Paper className={paper}>
        <FailureText variant="h5">
          <Trans>Účet nebyl nalezen</Trans>
        </FailureText>
      </Paper>
    </CenterContainer>
  )
}
